import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

// Import required modules
import { Pagination, Autoplay } from "swiper/modules";

const RatingStars = ({ rating }) => {
  const totalStars = 5;

  return (
    <div className="flex">
      {[...Array(totalStars)].map((_, index) => (
        <svg
          key={index}
          className={`w-6 h-6 ${
            index < rating ? "text-yellow-400" : "text-gray-300"
          }`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.95a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.36 2.445a1 1 0 00-.364 1.118l1.286 3.951c.3.92-.755 1.688-1.538 1.118l-3.36-2.444a1 1 0 00-1.176 0l-3.36 2.444c-.783.57-1.838-.197-1.538-1.118l1.286-3.95a1 1 0 00-.364-1.119L2.075 9.377c-.783-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.95z" />
        </svg>
      ))}
    </div>
  );
};

export default function Carousel({ data }) {

  const userdata = [
    {
      desc: "RentBro made finding my perfect apartment so easy! The verified listings gave me peace of mind, and the whole process was smooth from start to finish.",
      user: "Martin Goutry",
      city: "Los angeles",
      rating: 4,
      img: "/assets/home/user1.png",
    },
    {
      desc: "I loved how simple the platform is to use. The search filters were spot on, and the secure payments made everything hassle-free. Highly recommend!",
      user: "Michael K.",
      city: "New York",
      rating: 3,
      img: "/assets/home/user2.png",
    },
    {
      desc: "As a landlord, RentBro has been a game changer for managing my properties. The platform is reliable, and the customer support is always there when I need it.",
      user: "Michael K.",
      city: "Emily R.",
      rating: 4,
      img: "/assets/home/user3.png",
    },
    {
      desc: "RentBro made finding my perfect apartment so easy! The verified listings gave me peace of mind, and the whole process was smooth from start to finish.",
      user: "Martin Goutry",
      city: "Los angeles",
      rating: 4,
      img: "/assets/home/user1.png",
    },
    {
      desc: "I loved how simple the platform is to use. The search filters were spot on, and the secure payments made everything hassle-free. Highly recommend!",
      user: "Michael K.",
      city: "New York",
      rating: 4,
      img: "/assets/home/user2.png",
    },
    {
      desc: "As a landlord, RentBro has been a game changer for managing my properties. The platform is reliable, and the customer support is always there when I need it.",
      user: "Michael K.",
      city: "Emily R.",
      rating: 4,
      img: "/assets/home/user3.png",
    },
    {
      desc: "RentBro made finding my perfect apartment so easy! The verified listings gave me peace of mind, and the whole process was smooth from start to finish.",
      user: "Martin Goutry",
      city: "Los angeles",
      rating: 4,
      img: "/assets/home/user1.png",
    },
    {
      desc: "I loved how simple the platform is to use. The search filters were spot on, and the secure payments made everything hassle-free. Highly recommend!",
      user: "Michael K.",
      city: "New York",
      rating: 4,
      img: "/assets/home/user2.png",
    },
    {
      desc: "As a landlord, RentBro has been a game changer for managing my properties. The platform is reliable, and the customer support is always there when I need it.",
      user: "Michael K.",
      city: "Emily R.",
      rating: 4,
      img: "/assets/home/user3.png",
    },
  ];

  return (
    <div className="bg-reqBg py-8 bg-cover bg-no-repeat px-4 md:px-10 mt-32 xl:mt-60 2xl:mt-24">
          <h1 className="font-popinsSemiBold text-3xl md:text-4xl lg:text-5xl text-textColor text-center">
            What Our Users Say
          </h1>
          <p className="font-popinsRegular text-base text-textColor text-center w-[90%] lg:w-[50%] mx-auto mt-5 mb-14">
            See how RentBro has transformed rental experiences through the positive
            feedback and success stories of our satisfied users.
          </p>
          <Swiper
            spaceBetween={20}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 1.2,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
          >
            {userdata.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="text-left py-5 px-8 lg:px-4 rounded-md bg-white shadow-lg h-full">
                  <div className="w-[50%] mx-auto flex justify-center">
                    <RatingStars rating={item.rating} />
                  </div>
                  <p className="text-textColor font-popinsRegular text-base mt-4">
                    {item.desc}
                  </p>
                  <div className="lg:w-[50%] mx-auto flex items-center mt-4">
                    <img src={item.img} alt="" className="!size-14" />
                    <div className="pl-3">
                      <p className="font-popinsSemiBold text-lg text-textColor">
                        {item.user}
                      </p>
                      <p className="font-popinsRegular text-sm text-textColor">
                        {item.city}
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
  );
}
